import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpUtils } from '../../../../../common/http/http-utils';

@Injectable()
export class Service {
  value = '';

  constructor(public http: HttpClient) {
  }

  deleteVapp(vdcId, vappId) {
    let url = HttpUtils.getBaseUrl() + '/hybridity/api/dps/vdc/' + vdcId + '/vapp/' + vappId + '/policy';
    return this.http
      .delete(url)
      .map(
        (res: any) => this.value = res
      );
  }

  deleteVDC(vdcId) {
    let url = HttpUtils.getBaseUrl() + '/hybridity/api/dps/vdc/' + vdcId + '/policy';
    return this.http
      .delete(url)
      .map(
        (res: any) => this.value = res
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vcd/delete-policy/delete-policy.service.ts